<template>
  <div>
    <div v-if="spinner">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <div class="border" v-if="viewBatchOrderList.length > 0">
      <div class="row">
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12
            my-2
            form-inline
            justify-content-center
          "
        >
          <b class="m-1">Search title:</b>
          <b-form-input class="m-2" v-model="searchTitle"></b-form-input>
          <b-button
            class="buttonStyle my-2"
            variant="primary"
            @click="callSaveSearch()"
            >Save search</b-button
          >
        </div>
      </div>
    </div>
    <div class="border my-2 p-3" v-if="viewBatchOrderList.length > 0">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-checkbox
                v-model="assignInvoiceNumberStatus"
                :value="true"
                :unchecked-value="false"
                class="my-2"
              >
                Assign invoice number
              </b-form-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-input
                class="my-2"
                v-model="assignInvoiceNumber"
                :disabled="!assignInvoiceNumberStatus"
              ></b-form-input>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-checkbox
                v-model="createNewBatchNumberStatus"
                :value="true"
                :unchecked-value="false"
                class="my-2"
              >
                Create new batch number
              </b-form-checkbox>
              <b class="mx-3">Batch name:</b>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-input
                class="m-2 mt-4"
                v-model="createNewBatchName"
                :disabled="!createNewBatchNumberStatus"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-1">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-checkbox
                v-model="changeStatusFlag"
                :value="true"
                :unchecked-value="false"
                class="my-2"
              >
                Change status
              </b-form-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-select
                class="my-2"
                v-model="changeStatus"
                :options="orderStatus"
              ></b-form-select>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-checkbox
                v-model="setDateHandledStatus"
                :value="true"
                class="my-2"
                @change="setTodayDateInHandledStatus()"
              >
                Set date handled
              </b-form-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <input
                type="date"
                class="form-control m-2"
                v-model="setDateHandled"
                :disabled="!setDateHandledStatus"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-form-select
            class="my-2"
            v-model="exportFile"
            :options="exportFileType"
          ></b-form-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-button
            @click="updateBatch()"
            class="buttonStyle my-2"
            variant="primary"
            >Update batch</b-button
          >
        </div>
      </div>
    </div>
      <div class="row my-4" v-if="viewBatchOrderList.length > 0">
        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 form-inline">
          <b>Records per Screen</b>
          <b-form-select
            class="mx-2"
            v-model="filterRecordsPerScreen"
            :options="filterRecordsPerScreenOptions"
            @change="onChangeRecordsPerScreen()"
          ></b-form-select>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center">
          <div v-if="getIsBatchProcessSaveSearchRedirection.batchNumber">
            <b>#{{ getIsBatchProcessSaveSearchRedirection.batchNumber }}</b
            ><br />
            <b
              >CREATED:
              {{
                getIsBatchProcessSaveSearchRedirection.createdDate
                  ? moment(
                      getIsBatchProcessSaveSearchRedirection.createdDate
                    ).format("MM/DD/YYYY hh:mm A")
                  : ""
              }}</b
            ><br />
            <b v-if="getIsBatchProcessSaveSearchRedirection.handleDate"
              >HANDLED:
              {{
                moment(
                  getIsBatchProcessSaveSearchRedirection.handleDate
                ).format("MM/DD/YYYY hh:mm A")
              }}</b
            ><br />
            <span
              style="text-transform:uppercase;"
              v-html="getIsBatchProcessSaveSearchRedirection.batchName"
            ></span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-right">
          <h6>
            <span class="text-success">{{
              viewBatchPagination.totalRecords
            }}</span>
            RECORDS FOUND
          </h6>
        </div>
      </div>

      <div :class="{ border: viewBatchOrderList.length > 0 ? false : true }">
        <div v-if="viewBatchOrderList.length > 0">
          <b-table
            responsive
            :items="viewBatchOrderList"
            :fields="orderFields"
            style="width: 100%"
          >
            <template v-slot:cell(order)="data">
              <b-link
                :to="{
                  name: 'OrderDetails',
                  query: {
                    order_id: data.item.order_id,
                    order_number: data.item.order,
                  },
                }"
                :id="`popover-1-${data.item.order}`"
                target="_blank"
                >{{ data.item.order }}</b-link
              >
              <h6
                v-if="
                  getIsBatchProcessSaveSearchRedirection.batchNumber &&
                    !data.item.flag
                "
              >
                *
              </h6>
              <div v-if="getIsBatchProcessSaveSearchRedirection.batchNumber">
                <b-popover
                  placement="top"
                  :target="`popover-1-${data.item.order}`"
                  triggers="hover"
                  custom-class="rounded-0 bg-dark"
                >
                  <strong class="text-white"
                    >first handled on
                    {{
                      getIsBatchProcessSaveSearchRedirection.handleDate
                        ? moment(
                            getIsBatchProcessSaveSearchRedirection.handleDate
                          ).format("MM/DD/YYYY")
                        : moment(
                            getIsBatchProcessSaveSearchRedirection.createdDate
                          ).format("MM/DD/YYYY")
                    }}</strong
                  ></b-popover
                >
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <b-link
                :to="{
                  name: 'DivvyAdminUsersEditUser',
                  params: {
                    id: +data.item.name.id,
                  },
                }"
                target="_blank"
                >{{ data.item.name.name }}</b-link
              >
            </template>
            <template v-slot:cell(client)="data">
              <b-link
                :to="{
                  name: 'EditClient',
                  params: {
                    Id: +data.item.client.id,
                  },
                }"
                target="_blank"
                >{{ data.item.client.name }}</b-link
              >
            </template>
            <template v-slot:cell(product_name)="data">
              <b-link
                :to="{
                  name: 'EditProduct',
                  params: {
                    Id: +data.item.product_name.id,
                  },
                }"
                target="_blank"
                >{{ data.item.product_name.name }}</b-link
              >
            </template>
            <template v-slot:cell(SKU_product)="data">
              <b v-if="data.item.flag">Total order value: </b>
              <p v-else>{{ data.item.SKU_product }}</p>
            </template>
            <template v-slot:cell(cost)="data">
              <b v-if="data.item.flag"
                ><span class="text-success"
                  >$ {{ viewBatchPagination.totalDollars }} [
                  {{ viewBatchPagination.totalPoints }}
                  p. ]</span
                ></b
              >
              <b-link
                v-else
                :to="{
                  name: 'DivvyAdminUsersReportUser',
                  params: { id: +data.item.cost.id },
                }"
                :id="`popover-2-${data.item.order}`"
                target="_blank"
                >{{ data.item.cost.name }}</b-link
              >
              <b-popover
                :target="`popover-2-${data.item.order}`"
                triggers="hover"
                custom-class="rounded-0 bg-dark"
              >
                <strong class="text-white"
                  >points - click for report</strong
                ></b-popover
              >
            </template>
            <template v-slot:cell(action)="data">
              <div class="form-inline" v-if="!data.item.flag">
                <div class="form-check form-switch mx-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    v-model="orderIds"
                    :value="data.item.action"
                  />
                </div>
              </div>
            </template>
          </b-table>
          <div class="row my-3">
            <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
              <label
                >Viewing
                {{
                  filterRecordsPerScreen * viewBatchPagination.pageNo -
                    filterRecordsPerScreen +
                    1
                }}
                -
                {{
                  filterRecordsPerScreen * viewBatchPagination.pageNo <=
                  viewBatchPagination.totalRecords
                    ? filterRecordsPerScreen * viewBatchPagination.pageNo
                    : viewBatchPagination.totalRecords
                }}
                of {{ viewBatchPagination.totalRecords }} records
              </label>
            </div>
            <div class="col-sm-12 col-lg-6 col-md-6">
              <b-button-group class="float-right">
                <b-button
                  @click="firstPagination()"
                  :disabled="firstPage === viewBatchPagination.pageNo"
                  >&#60;&#60;</b-button
                >
                <b-button
                  @click="prevPagination()"
                  :disabled="firstPage === viewBatchPagination.pageNo"
                  >Prev</b-button
                >
                <b-button>{{ viewBatchPagination.pageNo }}</b-button>
                <b-button
                  @click="nextPagination()"
                  :disabled="
                    Math.ceil(
                      viewBatchPagination.totalRecords / filterRecordsPerScreen
                    ) === viewBatchPagination.pageNo
                  "
                  >Next</b-button
                >
                <b-button
                  @click="lastPagination()"
                  :disabled="
                    Math.ceil(
                      viewBatchPagination.totalRecords / filterRecordsPerScreen
                    ) === viewBatchPagination.pageNo
                  "
                  >>></b-button
                >
              </b-button-group>
            </div>
          </div>
        </div>

        <div v-else class="p-4 mx-2 text-center">
          <p>{{ getTableStatus }}</p>
        </div>
      </div>
  </div>
</template>
<script>
import {
  convertToDayMonthYear,
  getNowDateYearMonthDay,
} from "@/utilities/date.js";
import { fileDownload } from "@/utilities/downloadFile.js";

export default {
  name: "BatchProcessViewBatch",

  data() {
    return {
      status: "",
      changeStatus: "",
      exportFile: false,
      orderFields: [
        {
          key: "order",
          sortable: true,
        },
        {
          key: "name",
          sortable: true,
        },
        {
          key: "client",
          sortable: true,
        },
        {
          key: "order_date",
          sortable: true,
        },
        {
          key: "product_name",
          sortable: true,
          thStyle: { minWidth: "15rem" },
        },
        {
          key: "SKU_product",
          label: "SKU/Product #",
          sortable: true,
        },
        {
          key: "cost",
          sortable: true,
          thStyle: { minWidth: "10rem" },
        },
        {
          key: "supplier",
          sortable: true,
        },
        {
          key: "action",
        },
      ],
      orderItems: [],
      filterRecordsPerScreen: 0,
      pageNo: 1,
      firstPage: 1,
      searchTitle: "",
      assignInvoiceNumberStatus: false,
      assignInvoiceNumber: "",
      createNewBatchNumberStatus: false,
      createNewBatchName: "",
      changeStatusFlag: false,
      setDateHandledStatus: false,
      setDateHandled: "",
      changeStatusOptions: [],
      test: [],
      orderIds: [],
      spinner: false,
      saveSearchAfterRedirectionObj: {},
    };
  },

  methods: {
    firstPagination() {
      this.pageNo = 1;
      this.onChangeRecordsPerScreen();
    },
    prevPagination() {
      this.pageNo--;
      this.onChangeRecordsPerScreen();
    },
    nextPagination() {
      this.pageNo++;
      this.onChangeRecordsPerScreen();
    },
    lastPagination() {
      this.pageNo = Math.ceil(
        this.viewBatchPagination.totalRecords / this.filterRecordsPerScreen
      );
      this.onChangeRecordsPerScreen();
    },
    onChangeRecordsPerScreen() {
      this.spinner = true;

      this.orderItems = [];

      this.$store.commit("batchProcess/SET_TABLE_STATUS", "Processing");

      this.$store.commit(
        "batchProcess/SET_BATCH_PROCESS_IS_SAVE_SEARCH_REDIRECT",
        {
          redirect: false,
          showOrderDetails: {
            batchNumber: "",
            createdDate: "",
            batchName: "",
          },
        }
      );

      if (
        this.pageNo >
        Math.ceil(
          this.viewBatchPagination.totalRecords / this.filterRecordsPerScreen
        )
      ) {
        this.pageNo = 1;
      }

      var new_params = {
        bodyParams: this.getViewBatchStoreParams,
        params: {
          pg_num: this.pageNo,
          pg_size: this.filterRecordsPerScreen,
        },
      };

      this.$store
        .dispatch("batchProcess/fetchAllViewBatchList", new_params)
        .then(() => {
          this.spinner = false;
          this.$store.commit(
            "batchProcess/SET_TABLE_STATUS",
            "No records found"
          );
        })
        .catch(() => {
          console.log(
            "error occured from batch process form view batch change record per screen"
          );
        });
    },
    updateBatch() {
      this.spinner = true;
      var params = {
        assign_invoice_number: this.assignInvoiceNumberStatus,
        invoice_number: this.assignInvoiceNumber,
        create_new_batch_number: this.createNewBatchNumberStatus,
        batch_name: this.createNewBatchName,
        change_status: this.changeStatusFlag,
        status: this.changeStatus,
        set_date_handled: this.setDateHandledStatus,
        date_handled: this.setDateHandled,
        export_to_excel: this.exportFile,
        export_to_batch: false,
        order_ids: this.orderIds,
      };
      if (this.exportFile) {
        this.$store
          .dispatch("batchProcess/updateBatchProcessFileExport", {
            batch_number: this.createNewBatchName ?? "",
            order_ids: this.orderIds.map(Number),
          })
          .then((file) => {
            this.spinner = false;

            if (file.status === 200) {
              this.assignInvoiceNumberStatus = false;
              this.assignInvoiceNumber = "";
              this.createNewBatchNumberStatus = false;
              this.createNewBatchName = "";
              this.changeStatusFlag = false;
              this.changeStatus = "";
              this.setDateHandledStatus = false;
              this.setDateHandled = "";
              this.exportFile = false;

              fileDownload(file.data);
            }

            this.scrollToTop();
          })
          .catch(() => {
            console.log(
              "error occured from batch process saved search upload batch"
            );
          });
      } else {
        {
          this.$store.commit(
            "divvySystemMessage/SET_MODAL_MESSAGE",
            "If set date handled field is entered, it will be updated for the batch"
          );

          this.$store
            .dispatch("batchProcess/updateBatchProcess", params)
            .then(() => {
              this.spinner = false;

              // setting latest updated value in main and secondary order status
              this.$store.dispatch("batchProcess/fetchMainOrderStatus");
              this.$store.dispatch("batchProcess/fetchSecondaryStatus");

              this.assignInvoiceNumberStatus = false;
              this.assignInvoiceNumber = "";
              this.createNewBatchNumberStatus = false;
              this.createNewBatchName = "";
              this.changeStatusFlag = false;
              this.changeStatus = "";
              this.setDateHandledStatus = false;
              this.setDateHandled = "";
              this.exportFile = false;

              this.$router.push({ name: "BatchProcessSavedSearch" });
            })
            .catch(() => {
              console.log(
                "error occured from batch process saved search updateBatch"
              );
            });
        }
      }
    },
    callSaveSearch() {
      this.spinner = true;

      if (
        Object.keys(this.getBatchProcessViewBatchSaveSearchObj).length > 0 &&
        this.searchTitle
      ) {
        this.getBatchProcessViewBatchSaveSearchObj.title = this.searchTitle;

        this.getBatchProcessViewBatchSaveSearchObj.form_packet.data.struct.var.forEach(
          (field) => {
            if (field.key === "SMASTERSTATUS") {
              field.value = this.getViewBatchStoreParams.order_status_code;
            }
            if (field.key === "batchlabel") {
              field.value = this.getViewBatchStoreParams.batch_number;
            }
            if (field.key === "SORDERNUM") {
              field.value = this.getViewBatchStoreParams.order_number;
            }
            if (field.key === "SSTATUSCODE") {
              field.value = this.getViewBatchStoreParams.secondary_status_code;
            }
            if (field.key === "SBEGINDATE") {
              field.value = this.getViewBatchStoreParams.start_date;
            }
            if (field.key === "SENDDATE") {
              field.value = this.getViewBatchStoreParams.end_date;
            }
            if (field.key === "SINVOICENUM") {
              field.value = this.getViewBatchStoreParams.invoice_number;
            }
            if (field.key === "SDAYSBACK") {
              field.value = this.getViewBatchStoreParams.days_back.toString();
            }
            if (field.key === "SDATETYPE") {
              field.value = this.getViewBatchStoreParams.unhandled_orders_only
                ? "1"
                : "0";
            }
            if (field.key === "SBILLINGCODE") {
              field.value = this.getViewBatchStoreParams.billing_code;
            }
            if (field.key === "SSUPPLIER") {
              field.value = this.getViewBatchStoreParams.supplier_ids.toString();
            }
            if (field.key === "SCOMPANY") {
              field.value = this.getViewBatchStoreParams.company_ids.toString();
            }
            if (field.key === "searchTitle") {
              field.value = this.searchTitle;
            }
          }
        );

        this.$store
          .dispatch(
            "batchProcess/batchProcessSaveSearch",
            this.getBatchProcessViewBatchSaveSearchObj
          )
          .then(() => {
            this.spinner = false;

            this.$store.dispatch("batchProcess/fetchAllSavedSearch");

            this.searchTitle = "";

            this.scrollToTop();
          })
          .catch(() => {
            console.log(
              "error occured from batch process batchProcessSaveSearch method"
            );
          });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setTodayDateInHandledStatus() {
      if (!this.setDateHandledStatus && !this.setDateHandled) {
        this.setDateHandled = getNowDateYearMonthDay();
      }
    },
  },

  computed: {
    orderStatus() {
      var status = this.$store.getters["batchProcess/getMainOrderStatusArr"];
      var datas = [{ value: "", text: "Any" }];
      status.map(function(data) {
        datas.push({
          value: data.code,
          text: data.name,
        });
      });
      return datas;
    },
    exportFileType() {
      return this.$store.getters["batchProcess/getExportFileType"];
    },
    viewBatchPagination() {
      return this.$store.getters["batchProcess/getViewBatchPagination"];
    },
    viewBatchOrderList() {
      var batchOrderList = this.$store.getters[
        "batchProcess/getViewBatchOrderList"
      ];
      var datas = batchOrderList.map(function(data) {
        return {
          order: data.order_number,
          order_id: data.order_id,
          name: {
            name: `${data.first_name} ${data.last_name}`,
            id: data.user_id,
          },
          client: { name: data.client_name, id: data.client_id },
          order_date: data.order_date ? data.order_date : "",
          product_name: {
            name: `[ ${data.quantity} ] ${data.product_name}`,
            id: data.product_id,
          },
          SKU_product: data.sku ? `${data.sku} /` : "",
          cost: {
            name: `$${data.dollar_prod_cost} [ ${data.points} p. ]`,
            id: data.user_id,
          },
          supplier: data.supplier_name ? data.supplier_name : "",
          action: data.order_id.toString(),
        };
      });

      if (datas.length > 0) {
        datas.push({
          flag: "last",
          order: "",
          name: { name: "", id: "" },
          client: { name: "", id: "" },
          order_date: "",
          product_name: { name: "", id: "" },
          SKU_product: "Total order value:",
          cost: `$ ${this.viewBatchPagination.totalDollars} [
                  ${this.viewBatchPagination.totalPoints}
                  p. ]`,
          supplier: "",
          action: "",
        });
      }

      this.orderIds = datas.map((id) => id.action).filter((v) => v != "");

      return datas;
    },
    filterRecordsPerScreenOptions() {
      return this.$store.getters[
        "batchProcess/getFilterRecordsPerScreenOptions"
      ];
    },
    getViewBatchStoreParams() {
      return this.$store.getters["batchProcess/getViewBatchStoreParams"];
    },
    getBatchProcessViewBatchSaveSearchObj() {
      return this.$store.getters[
        "batchProcess/getBatchProcessViewBatchSaveSearchObj"
      ];
    },
    getTableStatus() {
      return this.$store.getters["batchProcess/getTableStatus"];
    },
    getIsBatchProcessSaveSearchRedirection() {
      var status = this.$store.getters[
        "batchProcess/getIsBatchProcessSaveSearchRedirection"
      ];
      if (status.redirect) {
        this.spinner = true;
      } else {
        this.spinner = false;
      }
      return status.showOrderDetails;
    },
  },
  watch: {
    viewBatchPagination(viewBatchPagination) {
      this.filterRecordsPerScreen = viewBatchPagination.pageSize;
      this.pageNo = viewBatchPagination.pageNo;
    },
    getIsBatchProcessSaveSearchRedirection(
      getIsBatchProcessSaveSearchRedirection
    ) {
      var status = this.$store.getters[
        "batchProcess/getIsBatchProcessSaveSearchRedirection"
      ];
      if (status.redirect) {
        this.spinner = true;
      } else {
        this.spinner = false;
      }
    },
  },
  created() {
    this.scrollToTop();
    this.getIsBatchProcessSaveSearchRedirection();
    this.$store.dispatch("batchProcess/fetchMainOrderStatus");
    this.$store.commit("batchProcess/SET_VIEW_BATCH_UPDATE_MESSAGE", {
      message: "",
      color: "",
    });
    this.$store.commit("batchProcess/SET_BATCH_MESSAGE", {
      message: "",
      color: "",
    });
  },
};
</script>
<style lang="scss" scoped>
form {
  border: 1px solid #ccc;
  padding: 25px;
  border-radius: 5px;
}

.form-switch .form-check-input {
  width: 2em;
  height: 1rem;
  margin-left: -1.5em !important;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

.table-active {
  opacity: 0.5;
}

.buttonStyle {
  border-radius: 1.5rem;
  // padding: 10px 20px;
}
</style>
